import { render } from "./newsInfo.vue?vue&type=template&id=eb356aa6&scoped=true"
import script from "./newsInfo.vue?vue&type=script&lang=js"
export * from "./newsInfo.vue?vue&type=script&lang=js"

import "./newsInfo.vue?vue&type=style&index=0&id=eb356aa6&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eb356aa6"]])

export default __exports__